import { FC, ReactNode } from 'react';
import { Modal, ModalProps as AntdModalProps, Divider } from 'antd';
import { genTestID } from '../utils/utils';
import styles from './styles.module.less';

type ModalProps = ComponentWithTagProps & AntdModalProps;

interface TitleWithDividerProps {
  title: ReactNode;
}

const TitleWithDivider: FC<TitleWithDividerProps> = ({ title }) => {
  return (
    <div>
      <span className={styles['modal-title']}>{title}</span>
      <Divider className={styles['modal-divider']} />
    </div>
  );
};

const TaggedModal: FC<ModalProps> = (props) => {
  const {
    tag, children, title, ...restProps
  } = props;

  const titleWithDivider = title ? <TitleWithDivider title={title} /> : undefined;

  return (
    <Modal {...restProps} title={titleWithDivider} data-testid={genTestID('modal', tag)}>
      {children}
    </Modal>
  );
};

export default TaggedModal;
